import type { ConnectedPosition } from '@angular/cdk/overlay';

/* AB#73512 — geometry of the design-system tooltip (`#appTip` in solvace-ui-prototypes):
   `top = r.bottom + 8` (below the trigger), `left = r.left` (aligned to its left edge, not
   centred), flipping up only when it would overflow. M = 8 is the prototype's margin. */
const TOOLTIP_OFFSET = 8;

// CDK narrows the viewport by the margin on both sides, then pushes against that width: 4 lands the right edge 8px from the window, the DS `data-tip` value.
export const TOOLTIP_VIEWPORT_MARGIN = 4;

export const TOOLTIP_POSITIONS_MAP: { [key: string]: ConnectedPosition } = {
  top: {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetY: -TOOLTIP_OFFSET,
  },
  bottom: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetY: TOOLTIP_OFFSET,
  },
  left: {
    originX: 'start',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
    offsetX: -TOOLTIP_OFFSET,
  },
  right: {
    originX: 'end',
    originY: 'center',
    overlayX: 'start',
    overlayY: 'center',
    offsetX: TOOLTIP_OFFSET,
  },
};

/** The prototype flips to the opposite side when the preferred one does not fit. Supplying the
 *  fallback to CDK makes it flip; with a single position it silently pushes the overlay instead. */
export const TOOLTIP_FALLBACK_POSITION: { [key: string]: string } = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
};
